import { MenuTabsWrap } from 'pages/menu/components/menu-tabs';
import FavoritesCardList from 'pages/menu/favorites-page/favorites-card-list';
import { useStoreRequired } from 'state/store/hooks/use-store-required';

export default function FavoritesScreen() {
  useStoreRequired();

  return (
    <MenuTabsWrap>
      <FavoritesCardList />
    </MenuTabsWrap>
  );
}
